import React from "react";

interface BlogPostSchemaProps {
  content: any; 
  seoData:any;
  logoUrl:any
}

const BlogPostSchema: React.FC<BlogPostSchemaProps> = ({  content ,seoData, logoUrl}) => {
  const dataSource = content?.data?.dataSource;
  const schema = {
    "@context": "http://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": dataSource?.url,
    },
    "headline": seoData?.title ?? "",
    "description": seoData?.description ?? "",
    "author": {
      "@type": "Organization",
      "name": "Caroma",
    },
    "publisher": {
      "@type": "Organization",
      "name": "Caroma",
      "logo": {
        "@type": "ImageObject",
        "url": logoUrl,
      },
    },
    "datePublished": dataSource?.date ?? "",
    "dateModified": dataSource?.date ?? "",
    "image": dataSource?.featured_image?.url ?? "",
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default BlogPostSchema;
